import React, { FC } from "react"

import * as s from "./CalloutQuote.module.scss"

type Props = {
  quote: string
  source: string
}

const CalloutQuote: FC<Props> = ({ quote, source }) => {
  return (
    <div className={s.container}>
      <p className={s.quote}>{quote}</p>
      <a className={s.source} href={source}>
        {source}
      </a>
    </div>
  )
}

export default CalloutQuote
